/**
 * Legacy landing for `/check-in/wall`.
 *
 * This route predates the decision to put the wall display on the public
 * check-in SWA. The real wall now lives at
 * `https://checkin.techsolvers.com.au/display`, where it can authenticate as a
 * device (its own key + a pinned IP) without dragging MSAL onto a kiosk
 * screen — see `docs/architecture/checkin-wall-tv-flow.md` in sm4rt-api.
 *
 * The route is kept because a TV somewhere may still be pointed at it, and a
 * screen that says where to go is far more useful than a 404. It is
 * unauthenticated and mounted pre-MSAL, same as the customer intake
 * placeholder.
 */

import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

const WALL_URL = 'https://checkin.techsolvers.com.au/display';

export const WallDisplayPlaceholder: React.FC = () => {
  return (
    <Box
      sx={{
        // 100dvh alone breaks on older TV browsers; 100vh is the fallback and
        // must come first (a duplicate key in one object silently drops one).
        minHeight: ['100vh', '100dvh'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f0f4f9',
        p: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 520,
          p: 4,
          textAlign: 'center',
          borderRadius: '10px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06), 0 0 0 0.5px rgba(0, 0, 0, 0.05)',
        }}
      >
        <Typography sx={{ mb: 1.5, fontSize: 20, fontWeight: 600, color: '#1a1a1a' }}>
          The wall display has moved
        </Typography>
        <Typography sx={{ fontSize: 14, color: '#333', lineHeight: 1.6, mb: 2 }}>
          Point this screen at the address below. It will show a pairing code, then a
          staff member approves it once in Admin&nbsp;&rsaquo;&nbsp;Wall&nbsp;Display.
        </Typography>
        <Typography
          sx={{
            fontSize: 15,
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
            color: '#4A90D9',
            wordBreak: 'break-all',
          }}
        >
          {WALL_URL}
        </Typography>
      </Paper>
    </Box>
  );
};
